package com.trevorwiebe.timesheet.loads.presentation.admin

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.trevorwiebe.timesheet.core.domain.model.Customer

@Composable
actual fun AddLoadDialog(state: LoadsState, onEvent: (LoadsEvent) -> Unit) {
    Dialog(
        onDismissRequest = { onEvent(LoadsEvent.OnDismissAddDialog) },
        // The default platform width caps the dialog at phone width; on desktop the
        // form lays out two columns instead, so let it grow to the window.
        properties = DialogProperties(usePlatformDefaultWidth = false)
    ) {
        val containerSize = LocalWindowInfo.current.containerSize
        val density = LocalDensity.current
        val maxWidth = with(density) { (containerSize.width * 0.94f).toDp() }
        val maxHeight = with(density) { (containerSize.height * 0.92f).toDp() }
        Card(
            shape = RoundedCornerShape(16.dp),
            modifier = Modifier
                .widthIn(max = minOf(maxWidth, 1080.dp))
                .heightIn(max = maxHeight),
        ) {
            Column(modifier = Modifier.padding(vertical = 16.dp)) {
                AddLoadFormContent(state = state, onEvent = onEvent)
            }
        }
    }
}

@Composable
actual fun CustomerSearchDialog(
    customers: List<Customer>,
    initialNewCustomer: Customer?,
    onSelect: (Customer) -> Unit,
    onNewCustomer: (Customer) -> Unit,
    onDismiss: () -> Unit,
    title: String,
    allowNewCustomer: Boolean,
    clearLabel: String?,
    onClear: (() -> Unit)?,
) {
    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = false)
    ) {
        CustomerSearchContent(
            customers = customers,
            initialNewCustomer = initialNewCustomer,
            onSelect = onSelect,
            onNewCustomer = onNewCustomer,
            onDismiss = onDismiss,
            title = title,
            allowNewCustomer = allowNewCustomer,
            clearLabel = clearLabel,
            onClear = onClear,
        )
    }
}
